export class OrderSummary {
    CanCancelOrder: boolean;
    CanInitiateClaim: boolean;
    CanUpdateClosingDate: boolean;
    CustomerName: string;
    DateString: string;
    EstimatedClosingDate: Date;
    EstimatedClosingDateString: string;
    Id: string;
    OrderDate: Date;
    PlanName: string;
    PropertyAddress: string;
    PropertyCity: string;
    PropertyState: string;
    PropertyZip: string;
    SellersCoverage: boolean;
    Status: string;
    Tenant: string = "5EA8C224-B3FF-4F11-B09F-5EC0C65266EC";
}
